import { Component, OnInit, Inject } from "@angular/core";
import { CommonService } from "../../../app/services/common.service";
import { Router, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import { DataService, Response } from "../../dataService/data.service";
import { GlobalVariable } from "../../app.component";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin } from "rxjs";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  NgForm,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-campaign-sms-tracking",
  templateUrl: "./campaign-sms-tracking.component.html",
  styleUrls: ["./campaign-sms-tracking.component.scss"],
})
export class CampaignSmsTrackingComponent implements OnInit {
  private BASE_URL = GlobalVariable;
  outlet_id: String = this.storage.get("outlet_id");
  slug_value: String;
  slug_value1: String;
  slug_value2: String;
  business_logo: string;
  business_name: string;
  customer_name: string;
  feedback: string;
  replied_by: string;
  feedback_reply: string;
  campaign_content: String;
  contact_fname: String;
  contact_lname: String;
  public loading = false;

  constructor(
    private commonservice: CommonService,
    private HttpService: DataService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private route: ActivatedRoute,
    public formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.loading = true;
    let res: Response;

    this.route.params.forEach((val) => {
      // this.slug_value = val['id'];
      this.slug_value1 = val.campaign_id;
      this.slug_value2 = val.contact_id;
      //  this.slug_value ='tsgcle';
      // console.log( this.slug_value,'id');
      // console.log( this.slug_value,'campaign_id');
      // console.log( this.slug_value1,'contact_id');
    });
    const json_data = {
      // 'slug': 'tsgcle',
      campaign_id: this.slug_value1,
      contact_id: this.slug_value2,
    };

    const logo_service = this.HttpService.put(
      this.BASE_URL.CAMPAIGN_TRACKING +
        "?campaign_id=" +
        this.slug_value1 +
        "&contact_id=" +
        this.slug_value2
    );
    logo_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        this.business_logo = res.data["business_details"].business_logo;
        this.business_name = res.data["business_details"].business_name;
        this.campaign_content = res.data["campaign"].campaign_content;
        this.contact_fname = res.data["contact_details"].name;
        this.contact_lname = res.data["contact_details"].last_name;
      }
    );
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loading = false;
    }, 2000);
  }
}
